import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TServiceCharge } from '../../types';

type TCategory = 'REGISTERED' | 'UNREGISTERED' | '';

export interface PackagesState {
  packages: TServiceCharge[];
}

const initialState: PackagesState = {
  packages: [],
};

export const packagesSlice = createSlice({
  name: 'packages',
  initialState,
  reducers: {
    setAllPackages: (state, action: PayloadAction<TServiceCharge[]>) => {
      state.packages = action.payload;
    },
  },
});

export const { setAllPackages } = packagesSlice.actions;

export default packagesSlice.reducer;
